import { run } from "@zootools/email-spell-checker"

export const isValidEmailSpelling = (email) => {
    const spellCheckValue = run({email});

    // if suggestions are available then its a typo
    return !Boolean(spellCheckValue);
}